@for (row of contentRows; track row) {
  <div class="row row-eq-height d-flex h100">
    @for (content of row; track content) {
      <app-content-block [content]="content"
        [ngClass]="{ 'col-md-12': row.length === 1,
                     'col-md-6': row.length === 2,
                     'col-md-4': row.length === 3 }" >
      </app-content-block>
    }
  </div>
}
